var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vdp-datepicker"},[_c('datePicker',{attrs:{"format":_vm.format,"lang":"pt-br","typeable":true,"placeholder":"00/00/0000","refName":"datepicker","inputClass":"form-control","type":_vm.type},on:{"change":_vm.onSelected},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }